export const getV2SCSSUrl = "/api/v1/point/type/restaurant/heatmap";
